<div class="modal-header">
    <h4 class="modal-title">
    <span>ronde {{gameRound.number}}</span>
    </h4>
    <button type="button" class="btn-close" aria-label="sluiten" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body p-0">
    @if( !processing()) {
        <div class="row justify-content-center g-0">
            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
            @if(gameRound && sourceAgainstGames().length > 0){                    
                <div class="mt-3">                
                    <againstgames-table-simple
                        [sourceAgainstGames]="sourceAgainstGames()"
                        [gameRound]="gameRound">
                    </againstgames-table-simple>
                </div>
            }
            @else {
                <h2 class="text-center">
                    <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
                </h2>
            }
            </div>
        </div>
    } @else {
        <h2 class="text-center">
            <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
        </h2>
    }
</div>